import { render } from "./BaseContainer.vue?vue&type=template&id=575b31fa&scoped=true"
import script from "./BaseContainer.vue?vue&type=script&lang=js"
export * from "./BaseContainer.vue?vue&type=script&lang=js"

import "./BaseContainer.vue?vue&type=style&index=0&id=575b31fa&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575b31fa"]])

export default __exports__